import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IoChevronDownSharp } from "react-icons/io5";

import Topbar from "../../../layout/Topbar";
import Footer from "../../../layout/Footer";
import {
  SCREEN_PATH,
  EMPTY_STRING,
  PAYLOAD_KEYS,
  agentConstants,
  propertySortingSelectOptions,
} from "../../../constants";
import { SUBSCRIPTION_STATUS } from "../../../system/global-enums";
import { buildFilterQuery } from "../../../shared/utility";
import SearchField from "../../../shared/components/search/SearchField";
import MainSpinner from "../../../shared/components/spinner/MainSpinner";
import RoundedButton from "../../../shared/components/buttons/RoundedButton";
import SliderControls from "../../../shared/components/slider/SliderControls";
import PropertyCardAgent from "../../../shared/components/property-card/PropertyCardAgent";
import MainContentWrapper from "../../../shared/components/main-content-wrapper/MainContentWrapper";
import {
  homeActions,
  adminActions,
  agentActions,
  countryAction,
  propertyActions,
} from "../../../redux/actions";

const propertiesPerPage = 10;
const { FILTER_QUERY, SEARCH, ORDER_BY } = PAYLOAD_KEYS;
const { PROPERTY_PAGINATION, GET_AGENT_LISTING } = agentConstants;

const MyListing = (props) => {
  const {
    allCountries,
    agentProperties,
    getAgentListing,
    getAllCountries,
    getAllCurrencies,
    propertyPagination,
    getAllViewTypes,
    getAllPropertyTypes,
    updatePropertyStatus,
    updatePagination,
    user: { userId, subscriptionStatus, isPaymentDisabled },
    spinnerActions,
  } = props;

  const [page, setPage] = useState(1);

  const getPageCount = (totalElements) => {
    const elementsPerPage = propertiesPerPage;
    return Math.ceil(totalElements / elementsPerPage);
  };

  // Get properties for the current page
  const paginatedProperties = agentProperties.slice(
    (page - 1) * propertiesPerPage,
    page * propertiesPerPage
  );

  const getFilterQuery = (data, countryFilter) => {
    const searchFields = ["Title"];

    // Build the initial filter query from the data
    let filter = buildFilterQuery(data, searchFields);

    // Dynamically append the filters based on their presence
    if (countryFilter && countryFilter !== EMPTY_STRING) {
      filter =
        filter !== EMPTY_STRING
          ? `(${filter}) && (${countryFilter})`
          : countryFilter;
    }

    return filter;
  };

  const getUpdatedPayload = () => {
    const updatedPayload = {
      ...propertyPagination,
      [FILTER_QUERY]: getFilterQuery(
        propertyPagination.search,
        propertyPagination.country
      ),
    };

    return updatedPayload;
  };

  const updateStatus = (id) => {
    updatePropertyStatus(id, () =>
      getAgentListing(userId, getUpdatedPayload())
    );
  };

  const spinner = useCallback(
    (type) => {
      return spinnerActions.findIndex((s) => s === type);
    },
    // eslint-disable-next-line
    [spinnerActions]
  );

  const handleUpdatePagination = (data, type) => {
    const payload = {
      ...propertyPagination,
      [SEARCH]: type === SEARCH ? data : propertyPagination.search,
      [ORDER_BY]: type === ORDER_BY ? data : propertyPagination.orderBy,
    };
    updatePagination(payload, PROPERTY_PAGINATION);
  };

  const handleChangeCountryFilter = (value) => {
    updatePagination(
      { ...propertyPagination, country: value },
      PROPERTY_PAGINATION
    );
  };

  const resetFilter = () => {
    updatePagination(
      {
        ...propertyPagination,
        search: EMPTY_STRING,
        orderBy: EMPTY_STRING,
        country: EMPTY_STRING,
        filterQuery: EMPTY_STRING,
      },
      PROPERTY_PAGINATION
    );
  };

  useEffect(() => {
    getAllCountries();
    getAllViewTypes();
    getAllCurrencies();
    getAllPropertyTypes();

    return () => {
      resetFilter();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getAgentListing(userId, getUpdatedPayload());
  }, [
    propertyPagination.search,
    propertyPagination.orderBy,
    propertyPagination.country,
  ]);

  return (
    <>
      <Topbar isAgent={true} />
      <MainContentWrapper className="pb-5">
        {spinner(GET_AGENT_LISTING) > -1 && <MainSpinner />}
        <div className="agent">
          <div className="container">
            <div className="text-center">
              <div className="listing-page-heading">My Listings</div>
              {isPaymentDisabled ||
              subscriptionStatus === SUBSCRIPTION_STATUS.ACTIVE ? (
                <Link to={SCREEN_PATH.CREATE_LISTING}>
                  <RoundedButton
                    className="create-list-btn mb-2"
                    cotainerClass="d-inline-block"
                  >
                    Create New Listing
                  </RoundedButton>
                </Link>
              ) : (
                <h5 className="text-danger">Kindly subscribe to add listing</h5>
              )}
            </div>
            <div
              className="
        d-flex 
        flex-wrap 
        flex-column 
        flex-lg-row 
        column-gap-4 
        align-items-lg-center
        my-listing-search-field
        "
            >
              <SearchField
                className="d-inline-block width-fit-content"
                value={propertyPagination.search}
                handleSearch={(val) => handleUpdatePagination(val, SEARCH)}
                placeholder="Search by property name"
              />
              <div
                className="
          d-flex 
          flex-wrap 
          column-gap-4 
          align-items-center
          "
              >
                <div className="position-relative select-field">
                  <select
                    className="mt-2 select-field-country"
                    value={propertyPagination.country}
                    onChange={(e) => handleChangeCountryFilter(e.target.value)}
                  >
                    <option value={EMPTY_STRING}>Country</option>
                    {allCountries.map((option) => (
                      <option key={option.id} value={`countryId=${option.id}`}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                  <IoChevronDownSharp className="mt-2" />
                </div>
                <div className="position-relative select-field">
                  <select
                    className="mt-2 select-field-sort"
                    value={propertyPagination.orderBy}
                    onChange={(e) =>
                      handleUpdatePagination(e.target.value, ORDER_BY)
                    }
                  >
                    <option value={EMPTY_STRING}>Sort By</option>
                    {propertySortingSelectOptions.map((option) => (
                      <option key={option.id} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <IoChevronDownSharp className="mt-2" />
                </div>
                <div
                  className="mt-1-8 reset-filter"
                  onClick={() => resetFilter()}
                >
                  Reset Filter
                </div>
              </div>
            </div>
            {paginatedProperties.length > 0 ? (
              <div className="listing row">
                {paginatedProperties.map((property) => (
                  <div className="col-12 col-md-6">
                    <PropertyCardAgent
                      property={property}
                      updateStatus={updateStatus}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center my-4 py-4">
                No property added yet!
              </div>
            )}
            {getPageCount(agentProperties.length) > 1 && (
              <div className="slider-controls">
                <SliderControls
                  length={getPageCount(agentProperties.length)}
                  changeIndex={(ind) => setPage(ind + 1)}
                />
              </div>
            )}
          </div>
        </div>
      </MainContentWrapper>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
  allCountries: state.countryReducer.allCountries,
  agentProperties: state.agentReducer.propertyList,
  propertyPagination: state.agentReducer.propertyPagination,
  spinnerActions: state.systemReducer.spinnerActions,
});

const mapDispatchToProps = (dispatch) => ({
  getAllCountries: () => dispatch(countryAction.getAllCountries()),
  getAllCurrencies: () => dispatch(homeActions.getAllCurrencies()),
  getAllPropertyTypes: () => dispatch(propertyActions.getAllPropertyTypes()),
  getAllViewTypes: () => dispatch(propertyActions.getAllViewTypes()),
  getAgentListing: (id, body) =>
    dispatch(agentActions.getAgentListing(id, body)),
  updatePropertyStatus: (id, func) =>
    dispatch(adminActions.updatePropertyStatus(id, func)),
  updatePagination: (data, type) =>
    dispatch(adminActions.updatePagination(data, type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyListing);
